import type { ContractArea, ForemanArea, ServiceArea } from '../../../services/areasService';

export interface AreaFilterValues {
  /** Service area name, '' for all. */
  serviceArea: string;
  /** Foreman area name, '' for all. */
  foremanArea: string;
}

export const EMPTY_AREA_FILTERS: AreaFilterValues = { serviceArea: '', foremanArea: '' };

/**
 * Exact (case-insensitive) name match. The filters are picked from a list of names, so a
 * substring match was wrong: "Service Area 1" also matched "Service Area 16".
 */
function sameName(a: string | null | undefined, b: string): boolean {
  return (a ?? '').trim().toLowerCase() === b.trim().toLowerCase();
}

export function filterServiceAreas(rows: ServiceArea[], f: AreaFilterValues): ServiceArea[] {
  if (!f.serviceArea) return rows;
  return rows.filter((sa) => sameName(sa.name, f.serviceArea));
}

export function filterForemanAreas(rows: ForemanArea[], f: AreaFilterValues): ForemanArea[] {
  return rows.filter(
    (fa) =>
      (!f.serviceArea || sameName(fa.serviceArea?.name, f.serviceArea)) &&
      (!f.foremanArea || sameName(fa.name, f.foremanArea)),
  );
}

export function filterContractAreas(rows: ContractArea[], f: AreaFilterValues): ContractArea[] {
  return rows.filter(
    (ca) =>
      (!f.serviceArea || (ca.foremanAreas ?? []).some((fa) => sameName(fa.serviceArea?.name, f.serviceArea))) &&
      (!f.foremanArea || (ca.foremanAreas ?? []).some((fa) => sameName(fa.name, f.foremanArea))),
  );
}

/** "1 contract area", "12 foreman areas", "0 foreman areas". */
export function countLabel(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
